import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { useSite } from "@/context/SiteContext";
import { shippingInfo } from "@/lib/product";

/** Verzendkosten + 'gratis vanaf' voor het land van de klant (CRM leidend). */
export function useShipping() {
  const { totalExcl } = useCart();
  const { account, verzendregels } = useAuth();
  const { instellingen } = useSite();
  return shippingInfo({ account, verzendregels, instellingen, totalExcl });
}
